import { createTextComponent } from './createTextComponent';

export const Underline = createTextComponent({
  tag: 'span',
  styleAs: 'underline',
});
